module.exports = __webpack_public_path__ + "img/tokyo-25.c0e7549e.png";